import { selectFeatures } from "store/slices/FeaturesSlice";
import HeaderNavigationLink from "../HeaderNavigationLink";
import FeaturesDropdownComponent from "./DropdownComponents/FeaturesDropdownComponent";
import { useSelector } from "react-redux";
import ROUTES from "constants/routes";


const FeaturesDropdown = ({ items, onClick }) => {

    const features = useSelector(selectFeatures)

    if (!features) return
    const featuresHeader = features?.map(item => ({
        title: item.attributes.preview_title,
        link: `${ROUTES.features}/${item.attributes.slug}`,
        icon: item.attributes.preview_icon
    }));


    return (
        <>
            <div className="header-nav__item__dropdown-section col-8">
                <div className="link">{items.our_features_sesction}</div>
                <div className="header-nav__item__dropdown-section-container">
                    {featuresHeader?.map((item, index) => (
                        <HeaderNavigationLink key={index} data={item} withColumn={true} onClick={onClick} />
                    ))}
                </div>
            </div>
            <div className="header-nav__item__dropdown-section col-4">
                <div className="link">{items.locations_section}</div>
                <FeaturesDropdownComponent onClick={onClick} />
            </div>
        </>
    );
}

export default FeaturesDropdown;